import { render } from "./Page.vue?vue&type=template&id=34d671e0&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=34d671e0&lang=css"
import "./Page.vue?vue&type=style&index=1&id=34d671e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d671e0"]])

export default __exports__